module.exports = __webpack_public_path__ + "img/help-libre.2513c77f.jpg";